import React from 'react'

function Notfound() {
    return (  
        <div className='container pt-2 mb-2'>
            <div className='row text-center'>
            <h1 className='mt-5 mb-3'>
            404 Not found !
            </h1>
            <h6>
            Online platform to invest in stocks, derivatives, mutual funds, ETFs, bonds, and more.
            </h6>
            
            </div>
        </div>
    );
}

export default Notfound;